import { graphql, useFragment } from "react-relay";
import {
  StorePermissions,
  usePermissions_store$key as sk,
} from "./__generated__/usePermissions_store.graphql";
import { PropsWithChildren } from "react";

export type usePermissions_store$key = sk;
export const useHasPermissions = (
  storeKey: usePermissions_store$key | undefined | null,
  permission: StorePermissions
) => {
  const store = useFragment(
    graphql`
      fragment usePermissions_store on Store {
        id
        myPermissions
      }
    `,
    storeKey
  );

  return store?.myPermissions?.includes(permission) ?? false;
};

export function HasPermission(
  props: PropsWithChildren<{
    store: usePermissions_store$key;
    permission: StorePermissions;
  }>
) {
  const hasPermission = useHasPermissions(props.store, props.permission);
  if (!hasPermission) {
    return null;
  }
  return props.children;
}
